import { useMemo } from 'react';
import { useAtom } from 'jotai';

import { authAtom } from '/src/machines/auth';
import { isSemrush } from '/src/utils/semrush';

/*
  Treat this as a read-only hook for simple context access

  const { isSharing } = useAuthContext();
*/
export function useAuthContext() {
  const [state] = useAtom(authAtom);

  const context = useMemo(() => ({ ...state.context }), [state.context]);
  const token = context.token;
  const normalizedToken =
    isSemrush && typeof token === 'string' && token.length > 0 && !token.startsWith('semrush_')
      ? `semrush_${token}`
      : token;

  return {
    ...context,
    token: normalizedToken,
  };
}
